export default class AccountRegisteredWithDifferentAuthProvider extends Error {
  constructor(message, authProvider) {
    super(message);
    this.authProvider = authProvider;
    this.name = "AccountRegisteredWithDifferentAuthProvider";
  }
}
